import React, { useEffect, useState } from 'react';
import Candidate from './Candidate';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import axios from "axios";

function KeyCandidates() {
    const [data, setData] = useState([]);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            try {
                const timestamp = new Date().getHours() + "" + new Date().getMinutes();
                const response = await axios.get(`/result/ACF2021/json/element335.json?ver=${timestamp}`);
                setData(response.data.items);
            } catch (error) {
                setError(error);
            } finally {
                setIsLoading(false);
            }
        };
        fetchData(); // No need for .then()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const settings = {
        arrows: true,
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        variableWidth: true,
        centerMode: false,
        responsive : [
            {
                breakpoint: 1231,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 390,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    if (isLoading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error: {error.message}</div>;
    }

    return (
        <Slider {...settings} className="card key-candidates">
            {data.map((item, index) => (
                <div key={index}>
                    <Candidate candidateData={item} /> {/* Pass data as props */}
                </div>
            ))}
        </Slider>
    );
}

export default KeyCandidates;
